<nz-content class="table-container">
    <div class="table-wrapper">
        <table-pro [config]="volumeConfig!" [currentPage]="0" [currentPageSize]="1000" [tableData]="[]"
            (resetClick)="resetVolumeSearch()" (searchClick)="searchVolumeClick($event)" [stickyTop]="40">
            <div class="grid overview">
                <div class="row" [style.width]="'100%'">
                    <div class="column no-border" [style.width]="'5rem'" [style.justifyContent]="'flex-start'">
                        <select [(ngModel)]="root.sectionId" [disabled]="true">
                            <option *ngFor="let item of projectSections" [value]="item.id">{{ item.name }}
                            </option>
                        </select>
                    </div>
                    <div class="column no-border" [style.width]="readonly ? '470px' : '100px'">
                        <format-data [contentStr]="title" [patternStr]="readonly ? 'E-460@@B' :'E-100@@B'">
                        </format-data>
                    </div>
                    <div class="column no-border color-primary fake-btn" [style.width]="'6rem'" *ngIf="!readonly"
                        (click)="fileNameRule()">
                        文件题名规则
                    </div>
                    <div class="column no-border color-primary fake-btn" [style.width]="'3rem'" (click)="volumeAdd()"
                        *ngIf="!readonly">
                        编卷
                    </div>
                    <div class="column no-border {{checkcount > 0 ? 'color-primary' : 'color-light'}} fake-btn"
                        [style.width]="'6rem'" (click)="batchDownload()">
                        批量下载({{checkcount}})
                    </div>
                    <div *ngIf="!readonly"
                        class="column no-border {{checkRemoveableCount > 0 ? 'color-primary' : 'color-light'}} fake-btn"
                        [style.width]="'6rem'" (click)="batchRemove()">
                        批量删卷({{checkRemoveableCount}})
                    </div>
                    <div class="column no-border color-primary fake-btn" [style.width]="'4rem'" (click)="sync()"
                        *ngIf="!readonly">
                        同步文件
                    </div>
                    <div class="column no-border {{!regular ? 'color-light' : 'color-primary'}} fake-btn"
                        *ngIf="!readonly" [style.width]="'3rem'">
                        +文件
                        <input *ngIf="!!regular" type="file" (change)="upload($event)" accept=".pdf">
                    </div>
                    <div class="column no-border color-primary fake-btn" [style.width]="'4rem'" (click)="clearVolume()"
                        *ngIf="!readonly">
                        清空文件
                    </div>
                </div>

            </div>

            <div class="checkall" [style.position]="'fixed'">
                <input type="checkbox" [(ngModel)]="volumeCheckAll" (ngModelChange)="onVolumeCheckAllChange()">
            </div>

            <div body>
                <table [style.left]="0" [style.width]="volumeConfigTotalWidth + 'px'">
                    <colgroup>
                        <col span="1" *ngFor="let item of volumeConfig?.columns ?? []"
                            [style.width]="(item.width * 100 / volumeConfigTotalWidth) + '%'">
                    </colgroup>
                    <tr *ngFor="let item of volumeRecordList ?? []; let index = index;">
                        <td>
                            <div class="checkbox">
                                <input type="checkbox" [(ngModel)]="item.selected" (ngModelChange)="onVolumeCheck()">
                            </div>
                        </td>
                        <td class="editable">
                            <select class="{{item.selected ? 'color-primary' : ''}}" [(ngModel)]="item.sortOrderTarget"
                                (ngModelChange)="onVolumeSortOrderChange(item)" [style.appearance]="'none'"
                                [style.textAlign]="'center'">
                                <option *ngFor="let opt of volumeSortOrderOpts" [value]="opt.value">{{ opt.label }}
                                </option>
                            </select>
                        </td>
                        <td [colSpan]="6">
                            <div>
                                <div class="cell" [style.width]="'260px'">
                                    <span class="color-light">{{!!item.code ? item.code : '-'}}</span>
                                </div>
                                <div class="cell" [style.width]="'160px'" *ngIf="item.fileStatusComment">
                                    <format-data [contentStr]="item.fileStatusComment" [patternStr]="'E+160@@CFF0000'">
                                    </format-data>
                                </div>
                                <p class="title-two-lines {{item.selected ? 'color-primary' : ''}}"> <b>
                                        {{item.title}} </b>
                                </p>
                                <div class="cell" [style.width]="'80px'">
                                    {{+item.filePageCount! + +item.fileAttachPageCount!}}
                                    <span class="color-grey">页</span>
                                </div>

                                <div class="cell color-light" [style.width]="'200px'">
                                    <span *ngIf="item.startTime && item.finishTime">
                                        {{item.startTime | date:'yyyy-MM-dd'}}
                                        ～
                                        {{item.finishTime | date:'yyyy-MM-dd'}}
                                    </span>
                                </div>
                                <span class="cell color-light" [style.width]="'60px'">
                                    {{ArchiveKeepPeriodTypeMap[item.keepPeriodType!]}}
                                </span>
                                <div class="cell color-light" [style.width]="'160px'" *ngIf="item.comment">
                                    <format-data [contentStr]="'备注:' + item.comment" [patternStr]="'E+160@@C2b58cd,3'">
                                    </format-data>
                                </div>
                            </div>
                        </td>
                        <td
                            class="text-center {{item.status === ArchiveStatus.LOCK ? 'color-warning' : ''}} {{item.status === ArchiveStatus.UNLOCK ? 'color-success' : ''}} {{item.status === ArchiveStatus.LOCKING ? 'color-dark-danger' : ''}}">
                            {{ArchiveStatusMap[item.status!]}}
                        </td>
                        <td *ngIf="!readonly">
                            <div class="btn-group">

                                <div class="line">
                                    <span
                                        class="fake-btn {{item.status === ArchiveStatus.UNLOCK ? 'color-primary' : 'color-light'}}"
                                        (click)="volumeEdit(index + (pager.pageIndex - 1) * pager.pageSize)">
                                        编辑
                                    </span>
                                    <span
                                        class="fake-btn {{item.status === ArchiveStatus.UNLOCK ? 'color-primary' : 'color-light'}}"
                                        (click)="volumeRemove(index + (pager.pageIndex - 1) * pager.pageSize)">
                                        删卷
                                    </span>
                                </div>
                                <div class="line">
                                    <span *ngIf="item.status !== ArchiveStatus.LOCK" class="fake-btn color-warning"
                                        (click)="volumeLock(index + (pager.pageIndex - 1) * pager.pageSize)">
                                        {{item.status === ArchiveStatus.LOCKING ? '继续' : ''}}锁卷
                                    </span>
                                    <span *ngIf="item.status === ArchiveStatus.LOCK" class="fake-btn color-success"
                                        (click)="volumeUnlock(index + (pager.pageIndex - 1) * pager.pageSize)">
                                        解锁
                                    </span>
                                    <span *ngIf="item.status !== ArchiveStatus.LOCK" class="fake-btn color-light">
                                        打印
                                    </span>
                                    <span *ngIf="item.status === ArchiveStatus.LOCK" class="fake-btn color-primary"
                                        nz-dropdown [nzDropdownMenu]="printMenu">
                                        打印
                                    </span>
                                    <nz-dropdown-menu #printMenu="nzDropdownMenu">
                                        <ul nz-menu>
                                            <li nz-menu-item (click)="volumePrint(item.volumePrintedFileId)">
                                                案卷（有页码）
                                            </li>
                                            <li nz-menu-item (click)="volumePrint(item.volumePrintedNoPageFileId)">
                                                案卷（无页码）
                                            </li>
                                            <li nz-menu-item (click)="volumePrint(item.volumeFrontCoverFileId)">
                                                案卷外封面
                                            </li>
                                            <li nz-menu-item (click)="volumePrint(item.volumeSpineFileId)">
                                                案卷背脊
                                            </li>
                                        </ul>
                                    </nz-dropdown-menu>
                                </div>
                                <div class="line">
                                    <span
                                        class="fake-btn {{item.status === ArchiveStatus.LOCK ? 'color-primary' : 'color-light'}}"
                                        (click)="volumeDownload(index + (pager.pageIndex - 1) * pager.pageSize)">
                                        下载电子档
                                    </span>
                                </div>
                            </div>
                        </td>
                    </tr>

                </table>
            </div>

        </table-pro>
    </div>
</nz-content>
<nz-footer class="footer">
    <nz-pagination class="footer-left" [nzPageIndex]="pager.pageIndex" [(nzPageSize)]="pager.pageSize"
        [nzPageSizeOptions]="pager.pageSizeOptions" [nzTotal]="pager.total" nzShowQuickJumper [nzShowSizeChanger]="true"
        [nzShowQuickJumper]="true" (nzPageIndexChange)="pageIndexChange($event)"
        (nzPageSizeChange)="pageSizeChange($event)">
    </nz-pagination>
</nz-footer>